import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  var lng = localStorage.getItem("I18N_LANGUAGE")
  return (
    <React.Fragment>
      <footer className={lng == "ar" ? "footer-ar" : "footer"}>
        <Container fluid={true}>
          <Row>
            <Col md={6}>{new Date().getFullYear()} © Cresus.</Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
